jQuery(document).ready(function ($) {
  var stickyOffset = $(".site-header-top");

  if (!stickyOffset.length) return;

  // stickyOffset = $(stickyOffset).offset().top + $(stickyOffset).innerHeight();
  stickyOffset = $(stickyOffset).innerHeight();

  function fixed_header(scroll) {
    var sticky = $(".site-header");

    if (scroll >= stickyOffset) {
      sticky.addClass("fixed");
    } else {
      sticky.removeClass("fixed");
    }
  }

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    fixed_header(scroll);
  });

  fixed_header($(window).scrollTop());
});
